import { Grid, Card, Typography } from '@mui/material'
import { getDisplayStatus, getSiteCount } from '../utils/aggregate'

// Cartões-resumo no topo — espelham os quatro estados canónicos do tracker
// (In Progress, Planned, Overdue, Closed) mais o total e os sites.
export default function KpiCards({ rows }) {
  const total    = rows.length
  const inProg   = rows.filter((r) => getDisplayStatus(r) === 'In Progress').length
  const planned  = rows.filter((r) => getDisplayStatus(r) === 'Planned').length
  const overdue  = rows.filter((r) => getDisplayStatus(r) === 'Overdue').length
  const closed   = rows.filter((r) => getDisplayStatus(r) === 'Closed').length
  const sites    = rows.reduce((s, r) => s + getSiteCount(r), 0)

  const cards = [
    { label: 'Activities',   value: total,   color: 'text.primary' },
    { label: 'In progress',  value: inProg,  color: 'primary.main' },
    { label: 'Planned',      value: planned, color: 'text.primary' },
    { label: 'Overdue',      value: overdue, color: '#c62828', danger: true },
    { label: 'Closed',       value: closed,  color: '#2e7d32' },
    { label: 'Sites',        value: sites,   color: 'text.primary' },
  ]

  return (
    <Grid container spacing={1.5}>
      {cards.map((c) => (
        <Grid item xs={6} sm={4} md={2} key={c.label}>
          <Card elevation={0} sx={{
            p: '12px 14px', borderRadius: 3,
            bgcolor: c.danger ? '#fdecec' : 'background.paper',
            border: '1px solid', borderColor: c.danger ? '#f5c6c6' : 'divider',
          }}>
            <Typography sx={{ fontSize: 12, color: c.danger ? '#c62828' : 'text.secondary' }}>{c.label}</Typography>
            <Typography sx={{ fontSize: 23, fontWeight: 600, lineHeight: 1.1, color: c.color }}>
              {Number(c.value).toLocaleString('en-GB')}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
